import { createCrewLookupSelect } from './createCrewLookupSelect';

export const EngineTypeSelect = createCrewLookupSelect('EngineTypeSelect', 'engineTypes');
export default EngineTypeSelect;
